import { Card, CardContent } from "@/components/ui/card";
import { CheckCircle2, Crown } from "lucide-react";

type LivePlanBannerProps = {
  userName?: string | null;
  className?: string;
};

const LivePlanBanner = ({ userName, className = "" }: LivePlanBannerProps) => {
  const displayName = userName?.trim() || "cliente";

  return (
    <section className={className} aria-labelledby="live-plan-banner-title">
      <Card className="overflow-hidden border-2 border-emerald-200 dark:border-emerald-800/60 bg-gradient-to-br from-emerald-50 via-teal-50/80 to-white dark:from-emerald-950/40 dark:via-teal-950/20 dark:to-slate-900 shadow-sm">
        <CardContent className="p-4 sm:p-5">
          <div className="flex flex-col sm:flex-row sm:items-start gap-3 sm:gap-4">
            <div
              className="p-2.5 sm:p-3 rounded-xl bg-gradient-to-br from-emerald-500 to-teal-600 text-white shrink-0 shadow-md"
              aria-hidden
            >
              <Crown className="h-6 w-6 sm:h-7 sm:w-7" />
            </div>
            <div className="flex-1 min-w-0 space-y-2 sm:space-y-3">
              <div>
                <p className="text-xs font-semibold uppercase tracking-wider text-emerald-700 dark:text-emerald-400 mb-1">
                  Plano Live ativo
                </p>
                <h2
                  id="live-plan-banner-title"
                  className="text-base sm:text-lg font-semibold text-slate-900 dark:text-slate-100"
                >
                  Parabéns, {displayName}! Você é cliente do plano Live
                </h2>
                <p className="text-sm text-slate-600 dark:text-slate-300 mt-1.5 leading-relaxed">
                  Aproveite todos os recursos da sua área{" "}
                  <span className="font-medium text-emerald-800 dark:text-emerald-300">
                    sem qualquer limitação
                  </span>
                  : gerencie imóveis, reservas, disponibilidade e documentos em todos os resorts da
                  Live Stay.
                </p>
              </div>
              <ul className="flex flex-wrap gap-2 text-xs text-slate-600 dark:text-slate-400">
                {[
                  "Imóveis ilimitados",
                  "Todos os resorts",
                  "Reservas e mensagens",
                  "Suporte prioritário",
                ].map((label) => (
                  <li
                    key={label}
                    className="inline-flex items-center gap-1.5 rounded-full bg-white/80 dark:bg-slate-800/80 border border-emerald-100 dark:border-emerald-900/50 px-2.5 py-0.5 sm:px-3 sm:py-1"
                  >
                    <CheckCircle2 className="h-3.5 w-3.5 text-emerald-600 dark:text-emerald-400 shrink-0" />
                    {label}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </CardContent>
      </Card>
    </section>
  );
};

export default LivePlanBanner;
